module.exports = __webpack_public_path__ + "static/media/boat.b9fec4c2.svg";